/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { useAppSelector } from '../reducers';
import { useMemo } from 'react';
import { RootInitiativeData } from '../types/initiative';


interface UseIsOrganizationIdParams {
  organization?: RootInitiativeData,
  initiativeId?: string
}

export const useIsOrganizationId = (params: UseIsOrganizationIdParams): { isLoaded: boolean, isValid: boolean} => {

  const gd = useAppSelector((state) => state.globalData);
  const { organization, initiativeId } = params;

  return useMemo(() => {

    if (!gd.loaded) {
      return { isLoaded: false, isValid: false,}
    }

    if (!organization) {
      return { isLoaded: gd.loaded, isValid: false }
    }

    const orgId = organization._id;
    if (!orgId || !initiativeId) {
      return { isLoaded: gd.loaded, isValid: false }
    }

    // Ensure initiativeId in the url is part of the tree
    const isValid = gd.data.initiativeTree.some(initiative => initiative._id === initiativeId);
    return { isLoaded: gd.loaded, isValid };

  }, [gd, organization, initiativeId])
}
